import React, { Component } from "react";
import Client from "../components/Contentful";

import ScrollDownYellow from "../assets/ScrollDownYellow.svg";
import ScrollDownBlack from "../assets/ScrollDownBlack.svg";

import { Element, scroller } from "react-scroll";
import ScrollAnimation from "react-animate-on-scroll";

export default class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      websites: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      let response = await Client.getEntries({
        //this is the content model ID
        content_type: "portfolioEntry",
        order: "sys.createdAt",
      });

      // console.log(response);
      this.setState({
        websites: response.items,
      });
    } catch {
      console.log("ERROR");
    }
  };

  scrollToPage = (index) => {
    console.log(index, typeof index);
    scroller.scrollTo(index, {
      duration: 600,
      delay: 100,
      smooth: true,
    });
  };

  render() {
    let length = this.state.websites.length - 1;
    const websites = this.state.websites.map((website, index) => {
      let color;
      let last;
      index !== length ? (last = " extra") : (last = "");
      index % 2 === 0 ? (color = " blue-bg") : (color = " tan-bg");
      return (
        <Element name={index.toString()} key={index}>
          <div
            className={
              index === 0
                ? "portfolio-page first" + color + last
                : "portfolio-page" + color + last
            }
          >
            <div className="wrapper portfolio-container">
              <ScrollAnimation animateIn="fadeInUp">
                <div className="portfolio-info">
                  <div className={index % 2 === 0 ? "title" : "title black"}>
                    {" "}
                    {website.fields.title}
                  </div>
                  <div
                    className={index % 2 === 0 ? "sub-text" : "sub-text black"}
                  >
                    {" "}
                    {website.fields.description}
                  </div>
                  <div className="btn-container">
                    {" "}
                    <a
                      href={website.fields.url}
                      className={index % 2 === 0 ? "btn" : "btn blue-bg"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Check it out
                    </a>
                  </div>
                </div>
              </ScrollAnimation>
              <div className="image-container">
                <ScrollAnimation animateIn="fadeInDown">
                  <img
                    src={website.fields.picture.fields.file.url}
                    alt=""
                    className="svg"
                  />
                </ScrollAnimation>
              </div>
            </div>
            {index !== length ? (
              <div
                onClick={() => this.scrollToPage((index + 1).toString())}
                className="scroll-down-container"
              >
                <img
                  src={index % 2 === 0 ? ScrollDownYellow : ScrollDownBlack}
                  alt=""
                  className="scroll-down"
                />
              </div>
            ) : null}
          </div>
        </Element>
      );
    });

    return <div className="portfolio">{websites}</div>;
  }
}
